import { format } from "rut.js";
import { responsables, responsablesCrear, responsablesEditar } from "../models/responsables";
import { actualizarResponsable, crearResponsable } from "../service/servicesResponsables";

export function useResponsable() {

    const save = async (data: responsables, dataediting: responsablesEditar | undefined) => {
        let dataRequest: responsablesCrear = {
            tipoResponsable: Number(data.responsabilidad),
            rut: format(data.rut, { dots: false }),
            nombres: data.nombres,
            apellidoPaterno: data.apellidoPaterno,
            apellidoMaterno: data.apellidoMaterno || "", 
            activo: data.estado, 
            email: data.email || null 
        };

        if (dataediting) {                    

            
            return await actualizarResponsable(dataRequest);
        }

        return await crearResponsable(dataRequest);
    }

    return {
        save
    }
}
